import React, { useEffect, useState, useRef } from "react";
import "./Nav.css";
import { NavLink, useLocation } from "react-router-dom";
import AnimateHeight from "react-animate-height";
import { ReactComponent as MenuIcon } from "./components/icons/menu.svg";
import { ReactComponent as CloseIcon } from "./components/icons/close.svg";
import * as Colors from "./Colors";
import IsMobile from "./IsMobile";

const sections = {
  Demographics: "demographics",
  School: "school",
  "Co-op": "coop",
  Lifestyle: "lifestyle",
  "Mental Health": "mental-health",
  "Sex, Drugs, & Relationships": "sex-drugs-relationships",
  "Personal Development": "personal-growth",
  "Future Plans": "future-plans",
  "Advice & Conclusions": "advice-conclusions",
  "Photo Gallery": "photos",
};

function NavHomeTitle() {
  return (
    <div className="SideNav-titlecontainer">
      <NavLink className="SideNav-title" to={"/"}>
        Tron 2020
      </NavLink>
    </div>
  );
}

function NavItems(props) {
  const location = useLocation();
  const pathname = location.pathname.replace("/", "");

  return (
    <React.Fragment>
      {Object.keys(sections).map((key) => (
        <NavLink
          className="SideNav-link"
          to={sections[key]}
          onClick={props.onClick}
          key={sections[key]}
        >
          <div className="SideNav-item">
            <span className="SideNav-shadowReference">
              {pathname === sections[key] && <div className="SideNav-shadow" />}
              {key}
            </span>
          </div>
        </NavLink>
      ))}
    </React.Fragment>
  );
}

function SideNav() {
  return (
    <div className="SideNav NavBorder">
      <NavHomeTitle />
      <div className="SideNav-itemContainer">
        <NavItems />
      </div>
    </div>
  );
}

function MobileNav() {
  const node = useRef();
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Taken from https://codesandbox.io/s/9o3lw5792w
  const handleClickOutside = (e) => {
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    setDrawerOpen(false);
  };

  useEffect(() => {
    if (drawerOpen) {
      document.addEventListener("touchstart", handleClickOutside);
    } else {
      document.removeEventListener("touchstart", handleClickOutside);
    }

    return () => {
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [drawerOpen]);

  return (
    <div ref={node} className="MobileNav NavBorder">
      <div className="MobileNav-topBar">
        <NavHomeTitle />
        {drawerOpen ? (
          <CloseIcon
            className="RightIcon"
            fill={Colors.PURPLE}
            onClick={() => setDrawerOpen(!drawerOpen)}
          />
        ) : (
          <MenuIcon
            className="RightIcon"
            fill={Colors.PURPLE}
            onClick={() => setDrawerOpen(!drawerOpen)}
          />
        )}
      </div>
      <AnimateHeight
        id="example-panel"
        duration={500}
        height={drawerOpen ? "auto" : 0}
      >
        <div className="MobileNav-itemContainer">
          <NavItems onClick={() => setDrawerOpen(false)} />
        </div>
      </AnimateHeight>
    </div>
  );
}

function Nav() {
  return IsMobile() ? <MobileNav /> : <SideNav />;
}

export default Nav;
